var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var PhotoDetailView = (function (_super) {
        __extends(PhotoDetailView, _super);
        function PhotoDetailView() {
            var _this = _super.call(this, { delegate: false }) || this;
            _this.$body = $('.js-Photo');
            _this.delegateEvent();
            return _this;
        }
        PhotoDetailView.prototype.delegateEvent = function () {
            _super.prototype.delegateEvent.call(this);
            Fily.ContentsView.load();
        };
        return PhotoDetailView;
    }(Fily.BaseView));
    Fily.PhotoDetailView = PhotoDetailView;
})(Fily || (Fily = {}));
